<template>
  <div class="login-page">
    <loading v-if="cargando" />
    
    <!-- Background with animated elements -->
    <div class="login-background">
      <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
        <div class="shape shape-4"></div>
      </div>
    </div>

    <div class="login-container">
      <div class="custom-login-box" style="max-width: 420px !important; width: 100% !important; min-width: 420px !important;">
        <div class="login-card">
          <!-- Header with enhanced branding -->
          <div class="login-header">
            <div class="brand-container">
              <div class="brand-icon">
                <i class="fas fa-truck-moving"></i>
              </div>
              <span class="brand-text app-brand-name">
                <strong>Movi <span class="highlight">7/24</span></strong>
              </span>
            </div>
            <p class="login-subtitle">Sistema de Gestión de Flota</p>
          </div>

          <!-- Login Form -->
          <div class="login-body">
            <p class="login-welcome">¡Bienvenido de vuelta!</p>
            <p class="login-instruction">Ingresa tus credenciales para acceder</p>
            
            <form @submit.prevent="login" method="post" class="login-form">
              <!-- Email Input -->
              <div class="form-group">
                <div class="input-container">
                  <div class="input-icon">
                    <i class="fas fa-envelope"></i>
                  </div>
                  <input
                    type="email"
                    v-model="form.email"
                    class="form-input"
                    placeholder="Correo electrónico"
                    :class="$v.form.email.$invalid ? 'is-invalid' : 'is-valid'"
                    required
                  />
                  <div class="input-focus-line"></div>
                </div>
                <div v-if="$v.form.email.$invalid && $v.form.email.$dirty" class="error-message">
                  <i class="fas fa-exclamation-circle"></i>
                  Por favor ingresa un email válido
                </div>
              </div>

              <!-- Password Input -->
              <div class="form-group">
                <div class="input-container">
                  <div class="input-icon">
                    <i class="fas fa-lock"></i>
                  </div>
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    class="form-input"
                    placeholder="Contraseña"
                    v-model="form.password"
                    :class="$v.form.password.$invalid ? 'is-invalid' : 'is-valid'"
                    required
                  />
                  <div class="password-toggle" @click="togglePassword">
                    <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" style="font-size: 16px; color: #a0aec0;"></i>
                  </div>
                  <div class="input-focus-line"></div>
                </div>
                <div v-if="$v.form.password.$invalid && $v.form.password.$dirty" class="error-message">
                  <i class="fas fa-exclamation-circle"></i>
                  La contraseña es requerida
                </div>
              </div>

              <!-- Remember Me & Submit -->
              <div class="form-options">
                <div class="remember-me">
                  <label class="checkbox-container">
                    <input type="checkbox" id="remember" />
                    <span class="checkmark"></span>
                    <span class="checkbox-label">Recordarme</span>
                  </label>
                </div>
                
                <button type="submit" class="login-btn" :disabled="cargando || !isFormValid">
                  <span v-if="!cargando">
                    <i class="fas fa-sign-in-alt"></i>
                    Entrar
                  </span>
                  <span v-else>
                    <i class="fas fa-spinner fa-spin"></i>
                    Iniciando sesión...
                  </span>
                </button>
              </div>
            </form>

            <!-- Forgot Password Link -->
            <div class="forgot-password">
              <router-link to="/ForgotPassword" class="forgot-link">
                <i class="fas fa-key"></i>
                ¿Olvidaste tu contraseña?
              </router-link>
            </div>
          </div>

          <!-- Footer -->
          <div class="login-footer">
            <div class="company-logo">
              <img
                src="/img/sos_logos/Logo_sos_contingencias.png"
                alt="SOS CONTINGENCIAS"
                class="logo-image"
              />
            </div>
            <p class="footer-text">Powered by SOS Contingencias</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../components/Loading";
import { required, email } from "vuelidate/lib/validators";
import { VueReCaptcha } from 'vue-recaptcha-v3';

export default {
  name: "Login",
  components: {
    Loading,
  },
  data: () => ({
    form: {
      email: "",
      password: "",
      recaptcha_token: "",
    },
    cargando: false,
    showPassword: false,

  }),
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  computed: {
    isFormValid() {
      return this.form.email && this.form.password && 
             this.form.email.trim() !== '' && 
             this.form.password.trim() !== '';
    }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async login() {
      // Validar formulario antes de enviar
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      
      this.cargando = true;
      
      // Generar token de reCAPTCHA v3
      try {
        this.form.recaptcha_token = await this.$recaptcha('login');
      } catch (error) {
        // Continuar sin reCAPTCHA si falla
        this.form.recaptcha_token = '';
      }
      
      try {
        const result = await this.$store.dispatch("login", this.form);
        // Credenciales OK: el backend pide OTP → pantalla de verificación 2FA
        if (result?.requires_2fa) {
          this.cargando = false;
          this.$router.push({ name: "Verificar2FA" });
          return;
        }
      } catch (error) {
        this.cargando = false;
        this.$swal({
          icon: "error",
          title: "Error de conexión",
          text: "No se pudo conectar con el servidor. Verifica tu conexión.",
        });
        return;
      }
      if (this.$store.getters.isAuthenticated) {
        this.cargando = false;
        window.location.href = "/";
      } else {
        this.cargando = false;
        if (this.$store.getters.getErrors == "password_expired") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Ha pasado mucho tiempo sin actualizar la contraseña, por favor cámbiela! Le enviamos un código de verificación a " + this.form.email,
          });
          this.$store.commit("SET_ERRORS", null);
          return this.$router.push({
            name: "CambiarClave",
            params: {
              email: this.form.email,
            },
          });
        } else if (this.$store.getters.getErrors === "recaptcha") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Error de verificación de recaptcha, creemos que eres un robot!!",
          });
        } else if (this.$store.getters.getErrors === "status") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Usuario inactivo, por favor comuníquese con el administrador funcional de la plataforma",
          });
        } else if (this.$store.getters.getErrors === "estado_empresa}") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "La empresa del usuario está inactiva, por favor comuníquese con el administrador funcional de la plataforma",
          });
        } else if (this.$store.getters.getErrors === "email") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: this.$store.getters.getMensajeLogin,
          });
        } else if (this.$store.getters.getErrors === "destiempo") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "No es posible ingresar en este horario, inténtelo más tarde.",
          });
        } else if (this.$store.getters.getErrors === "mail_failed") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: this.$store.getters.getMensajeLogin || "No se pudo enviar el correo de verificación.",
          });
          this.$store.commit("SET_ERRORS", null);
        } else {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "El usuario o la contraseña son incorrectas!",
          });
        }
      }
    },

  },
};
</script>
<style scoped>
/* Estilos movidos a /src/assets/styles.css */
</style>
